var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12C10.2426 12 11.25 10.9926 11.25 9.75C11.25 8.50736 10.2426 7.5 9 7.5C7.75736 7.5 6.75 8.50736 6.75 9.75C6.75 10.9926 7.75736 12 9 12Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.0227C1 7.72455 1 6.57541 1.56176 5.74995C1.80496 5.39261 2.11746 5.08578 2.48143 4.84701C3.02166 4.4926 3.698 4.36592 4.7335 4.32064C5.22764 4.32064 5.65309 3.95301 5.75 3.47727C5.89536 2.76367 6.53354 2.25 7.27472 2.25H9.72527C10.4664 2.25 11.1046 2.76367 11.25 3.47727C11.3469 3.95301 11.7723 4.32064 12.2665 4.32064C13.302 4.36592 13.9783 4.4926 14.5186 4.84701C14.8825 5.08578 15.195 5.39261 15.4382 5.74995C16 6.57541 16 7.72455 16 10.0227C16 12.3209 16 13.4701 15.4382 14.2955C15.195 14.6528 14.8825 14.9597 14.5186 15.1985C13.6778 15.75 12.5075 15.75 10.1666 15.75H6.83333C4.49256 15.75 3.32218 15.75 2.48143 15.1985C2.11746 14.9597 1.80496 14.6528 1.56176 14.2955C1.4031 14.0623 1.28924 13.8034 1.20755 13.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.5H13.5",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.02e859b37c429641f46629004f59038e.svg";
export { ForwardRef as ReactComponent };